import { render, staticRenderFns } from "./filter-tag.vue?vue&type=template&id=14714c85&scoped=true&"
import script from "./filter-tag.vue?vue&type=script&lang=js&"
export * from "./filter-tag.vue?vue&type=script&lang=js&"
import style0 from "./filter-tag.vue?vue&type=style&index=0&id=14714c85&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14714c85",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
